var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOlLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 268 267",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeMiterlimit: 10
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-7927,-3239)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-9",
    serifId: "Page 9",
    transform: "matrix(1,0,0,1,6750,2250)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer-2",
    serifId: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,964.106,1032.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L181.441,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(49,57,65)",
      strokeWidth: 24
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,963.88,1119.99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L181.441,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(49,57,65)",
      strokeWidth: 24
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,964.633,1212.72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L181.441,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(49,57,65)",
      strokeWidth: 24
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1250.46,1032.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L181.441,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(49,57,65)",
      strokeWidth: 24
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1250.23,1119.99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L181.441,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(49,57,65)",
      strokeWidth: 24
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1250.99,1212.72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L181.441,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(49,57,65)",
      strokeWidth: 24
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.53223,0,0,1.53223,-10981.3,-3995.72)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "7948.17px",
    y: "3308.67px",
    style: {
      fontFamily: "'AppleSDGothicNeo-Bold', 'Apple SD Gothic Neo'",
      fontWeight: 700,
      fontSize: "65.602px",
      fill: "rgb(49,57,65)"
    }
  }, "1")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.53223,0,0,1.53223,-10987.8,-3909.16)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "7948.17px",
    y: "3308.67px",
    style: {
      fontFamily: "'AppleSDGothicNeo-Bold', 'Apple SD Gothic Neo'",
      fontWeight: 700,
      fontSize: "65.602px",
      fill: "rgb(49,57,65)"
    }
  }, "2")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.53223,0,0,1.53223,-10986.4,-3819.06)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "7948.17px",
    y: "3308.67px",
    style: {
      fontFamily: "'AppleSDGothicNeo-Bold', 'Apple SD Gothic Neo'",
      fontWeight: 700,
      fontSize: "65.602px",
      fill: "rgb(49,57,65)"
    }
  }, "3"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOlLight);
export default __webpack_public_path__ + "static/media/ol_light.eef94b541bc1f17b2be06a81ec4ac978.svg";
export { ForwardRef as ReactComponent };